module.exports = __webpack_public_path__ + "static/media/img_plan_lite.6011b75b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_plan_lite.svg
// module id = 386
// module chunks = 0